(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fall-sale-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fst8Init) return;
    window.__fst8Init = true;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function secondsToMidnight(tz) {
      try {
        var parts = {};
        new Intl.DateTimeFormat('en-US', {
          timeZone: tz || undefined,
          hourCycle: 'h23',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        var h = parseInt(parts.hour, 10) % 24;
        return 86400 - (h * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10));
      } catch (e) {
        var d = new Date();
        return 86400 - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds());
      }
    }

    function tick() {
      document.querySelectorAll('.fst-8[data-fst-tz]').forEach(function (el) {
        var s = secondsToMidnight(el.getAttribute('data-fst-tz'));
        var v = { h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        el.querySelectorAll('[data-u]').forEach(function (u) {
          u.textContent = pad(v[u.getAttribute('data-u')]);
        });
      });
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    class SwatchScrollArrow extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('product-swatches');
      this.button = this.querySelector('button');
      this.onScroll = () => this.update();
      this.onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const list = this.list;
        if (!list) return;
        if (this.classList.contains('is-end')) {
          list.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          list.scrollBy({ left: Math.max(list.clientWidth * 0.8, 60), behavior: 'smooth' });
        }
      };
      this.button?.addEventListener('click', this.onClick);
      this.attempts = 0;
      this.init();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.boundList?.removeEventListener('scroll', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
    }

    get list() {
      const overflowList = this.host?.querySelector('overflow-list');
      return overflowList?.shadowRoot?.querySelector('[part="list"]') || null;
    }

    init() {
      const list = this.list;
      if (!list) {
        if (this.attempts++ < 20) setTimeout(() => this.init(), 150);
        return;
      }
      this.boundList = list;
      list.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(list);
      if (this.host) this.resizeObserver.observe(this.host);
      const overflowList = this.host?.querySelector('overflow-list');
      if (overflowList) {
        this.mutationObserver = new MutationObserver(() => this.update());
        this.mutationObserver.observe(overflowList, { subtree: true, attributes: true, attributeFilter: ['slot'] });
      }
      this.update();
      setTimeout(() => this.update(), 500);
      setTimeout(() => this.update(), 1500);
    }

    update() {
      const list = this.list;
      if (!list || !this.host) return;
      const overflowing = list.scrollWidth > list.clientWidth + 2;
      this.host.classList.toggle('is-overflowing', overflowing);
      const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      this.classList.toggle('is-end', overflowing && atEnd);
      this.button?.setAttribute('aria-label', overflowing && atEnd ? 'Back to first colors' : 'More colors');
    }
  }

  if (!customElements.get('swatch-scroll-arrow')) {
    customElements.define('swatch-scroll-arrow', SwatchScrollArrow);
  }
  } catch(e) { console.error(e); }
})();

})();
